export const eCommerceEvents = [
    'purchase',
    'refund',
    'view_item_list',
    'view_item',
    'select_item',
    'view_promotion',
    'select_promotion',
    'add_to_cart',
    'add_to_wishlist',
    'remove_from_cart',
    'view_cart',
    'begin_checkout',
    'add_payment_info',
    'add_shipping_info',
];
/**
 * Checks if the event coming in is part of the e-commerce events.
 */
export function isAnEcommerceEvent(eventObject) {
    if ('event' in eventObject && eCommerceEvents.includes(eventObject.event)) {
        return true;
    }
    return false;
}
